var canRunClickFunc = true;

function makeTouchstartWithClick(e) {
    if (!canRunClickFunc) return false;
    setTimeout(function() {
        canRunClickFunc = true;
    }, 700);
    
    var t = e.target;
    var r = t.closest(".close-drawer");
    if (t.classList.contains("close-drawer") || r) {
        document.querySelector("body").classList.remove("filter-open");
        document.querySelector("body").classList.remove("mobile-toggled");
        return;
    }
    r = t.closest(".menu-toggle");
    if (t.classList.contains("menu-toggle") || r) {
        e.stopPropagation();
        e.preventDefault();
        document.querySelector("body").classList.add("mobile-toggled");
        return;
    }
    if (t.classList.contains("mobile-overlay")) {
        document.querySelector("body").classList.remove("filter-open");
        document.querySelector("body").classList.remove("mobile-toggled");
        return;
    }
    r = t.closest(".mobile-search-toggle");
    if (t.classList.contains("mobile-search-toggle") || r) {
        e.stopPropagation();
        e.preventDefault();
        document.querySelector("body").classList.toggle("m-search-toggled");
        return;
    }
    r = t.closest(".add_to_cart_button");
    if (t.classList.contains("add_to_cart_button")) {
        document.querySelector("body").classList.remove("mobile-toggled");
    }
}

function makeOnTouchTapped() {
    if (window.innerWidth > 992 && "ontouchstart" in window) {
        document.addEventListener("touchstart", function() {}, { passive: true });
        document.addEventListener("click", function(e) {
            var t = e.target;
            if (!t.classList.contains("menu-item-has-children")) {
                var r = t.closest(".menu-item-has-children");
                if (!r) return;
                t = r;
            }
            var n = document.querySelectorAll(".menu-item-has-children.tapped");
            if (n) n.forEach(function(e) {
                if (e !== t) e.classList.remove("tapped");
            });
            if (t.classList.contains("tapped")) return;
            t.classList.add("tapped");
            e.preventDefault();
            return false;
        }, true);
    }
}

document.addEventListener("DOMContentLoaded", function() {
    window.addEventListener("load", function(e) {
        var t = .01 * window.innerHeight;
        document.documentElement.style.setProperty("--vh", t + "px");
        makeOnTouchTapped();
    });

    window.addEventListener("resize", function(e) {
        var t = .01 * window.innerHeight;
        document.documentElement.style.setProperty("--vh", t + "px");
        makeOnTouchTapped();
    });

     window.addEventListener("click", function(e) {
        var t = e.target;
    //     var r = t.closest(".shoptimizer-mobile-filter");
    //     if (t.classList.contains("shoptimizer-mobile-toggle") || r) {
    //         e.stopPropagation();
    //         e.preventDefault();
    //         document.querySelector("body").classList.toggle("filter-open");
    //         return;
    //     }
        makeTouchstartWithClick(e);
        canRunClickFunc = false;
    });

    window.addEventListener("touchstart", function(e) {
        makeTouchstartWithClick(e);
        canRunClickFunc = false;
    }, { passive: false });

});

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector("#ProductSubmitButton-template--17963437949028__main");
  const spinner = btn?.querySelector(".loading__spinner");

  if (!btn || !spinner) return;

  // Variant change start
  document.querySelector("variant-selects")?.addEventListener("change", () => {
    btn.classList.add("loading");
    btn.disabled = true;
    spinner.classList.remove("hidden"); 
  });

  // Variant loaded
  if (typeof subscribe === "function") {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      btn.classList.remove("loading");
      btn.disabled = false;
      spinner.classList.add("hidden"); 
    });
  }
});



